var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSummeringInteOk25Px25Px = function SvgSummeringInteOk25Px25Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#BA0C2F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5h1v1h-1zM12 5.5h1v10h-1z"
  })))));
};
export default SvgSummeringInteOk25Px25Px;